import { render } from "./PermissionsStepsGuide.vue?vue&type=template&id=671c4f5f&scoped=true&ts=true"
import script from "./PermissionsStepsGuide.vue?vue&type=script&lang=ts"
export * from "./PermissionsStepsGuide.vue?vue&type=script&lang=ts"

import "./PermissionsStepsGuide.vue?vue&type=style&index=0&id=671c4f5f&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671c4f5f"]])

export default __exports__